// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4df449af","239":"1efa5efc","453":"ce8d91d6","455":"37aff504"}[chunkId] + ".chunk.js";
};